import { useState } from 'react'

import {
	MobileSelect,
	type MobileSelectProps,
	MobileSelectTrigger,
	type MobileSelectTriggerProps
} from '@/shared/ui/Selector/ui/mobile-select/mobile-select'

type MobileSortProps<T extends string> = {
	className?: string
	triggerLabel?: string
	variant?: MobileSelectTriggerProps['variant']
	selectionStyle?: MobileSelectProps['selectionStyle']
	closeControl?: MobileSelectProps['closeControl']
	options: {
		value: T
		label: string
	}[]
	value: T
	onChange?: (value: T) => void
}

export const MobileSort = <T extends string>(props: MobileSortProps<T>) => {
	const { className, triggerLabel, variant, selectionStyle, closeControl, options, onChange, value } = props
	const [open, setOpen] = useState(false)
	const activeOption = options.find(opt => opt.value === value)

	const onChangeHandler = (newValue: string | string[]) => {
		if (Array.isArray(newValue)) return

		const option = options.find(option => option.value === newValue)
		if (option) onChange?.(option.value)
	}

	return (
		<>
			<MobileSelectTrigger
				className={className}
				variant={variant}
				label={triggerLabel ?? activeOption.label}
				onClick={() => setOpen(true)}
			/>
			<MobileSelect
				selectionStyle={selectionStyle}
				closeControl={closeControl}
				title="Сортировка товара"
				options={options}
				value={value}
				isOpen={open}
				onClose={() => setOpen(false)}
				onChange={onChangeHandler}
			/>
		</>
	)
}
